import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const [services, setServices] = useState([]);

  useEffect(() => {
    fetch('https://api.dev.auxo.dk/public/content/ydelser')
      .then((res) => res.json())
      .then((data) => {
        if (Array.isArray(data)) {
          // Show top 6 services in footer to keep it clean
          setServices(data.slice(0, 6));
        }
      })
      .catch((err) => console.error('Error fetching services for footer:', err));
  }, []);

  return (
    <footer className="relative overflow-hidden bg-brand-navy-900 text-white border-t border-brand-navy-800">
      {/* Background Image with high transparency */}
      <div className="absolute inset-0 pointer-events-none select-none">
        <img
          src="https://assets.auxodev.dk/cdn-cgi/image/width=1600,quality=70,format=auto/assets/af349c16-3f04-4dd3-a862-642e24736c63/moderne-entreprenoermaskiner.jpg"
          alt="Entreprenørmaskiner og gravemaskiner fra Entreprenør Jan Nørgaard ApS maskinpark"
          title="Entreprenør Jan Nørgaard ApS moderne maskinpark"
          className="w-full h-full object-cover opacity-25"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-brand-navy-950/80 via-brand-navy-900/65 to-brand-navy-900/75" />
      </div>

      {/* Top Section */}
      <div className="relative z-10 mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8 lg:py-16">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          {/* Company Info */}
          <div className="flex flex-col gap-4">
            <Link to="/" className="flex items-center gap-3 group">
              <img
                src="https://assets.auxodev.dk/cdn-cgi/image/width=200,quality=90,format=auto/assets/af349c16-3f04-4dd3-a862-642e24736c63/entreprenoer-jan-noergaard-logo.png"
                alt="Entreprenør Jan Nørgaard ApS firmalogo - Hvid udgave"
                title="Entreprenør Jan Nørgaard ApS"
                className="h-9 w-auto object-contain brightness-0 invert opacity-90 transition-opacity group-hover:opacity-100"
              />
            </Link>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-display text-sm font-bold uppercase tracking-wider text-white">
              Navigation
            </h3>
            <ul className="mt-4 space-y-2 text-sm text-brand-navy-300">
              <li>
                <Link to="/" className="hover:text-brand-orange-400 transition-colors">
                  Forside
                </Link>
              </li>
              <li>
                <Link to="/om-os" className="hover:text-brand-orange-400 transition-colors">
                  Om os
                </Link>
              </li>
              <li>
                <Link to="/referencer" className="hover:text-brand-orange-400 transition-colors">
                  Referencer
                </Link>
              </li>
              <li>
                <Link to="/kontakt" className="hover:text-brand-orange-400 transition-colors">
                  Kontakt
                </Link>
              </li>
            </ul>
          </div>

          {/* Featured Services */}
          <div>
            <h3 className="font-display text-sm font-bold uppercase tracking-wider text-white">
              Udvalgte Ydelser
            </h3>
            <ul className="mt-4 space-y-2 text-sm text-brand-navy-300">
              {services.map((service) => (
                <li key={service.id}>
                  <Link
                    to={`/ydelser/${service.slug.da}`}
                    className="hover:text-brand-orange-400 transition-colors"
                  >
                    {service.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-display text-sm font-bold uppercase tracking-wider text-white">
              Kontakt os
            </h3>
            <ul className="mt-4 space-y-3 text-sm text-brand-navy-300">
              <li className="flex items-start gap-2.5">
                <i className="fa-solid fa-location-dot text-white mt-1" />
                <span>
                  Entreprenør Jan Nørgaard ApS
                  <br />
                  Ørstedvej 22
                  <br />
                  6560 Sommersted
                </span>
              </li>
              <li className="flex items-center gap-2.5">
                <i className="fa-solid fa-phone text-white" />
                <a
                  href="tel:+4520483818"
                  className="hover:text-brand-orange-400 transition-colors whitespace-nowrap"
                >
                  20 48 38 18
                </a>
              </li>
              <li className="flex items-center gap-2.5">
                <i className="fa-solid fa-envelope text-white" />
                <a
                  href="mailto:jan@jannoergaard.dk"
                  className="hover:text-brand-orange-400 transition-colors whitespace-nowrap"
                >
                  jan@jannoergaard.dk
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="mt-12 border-t border-brand-navy-800 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-brand-navy-500">
          <p>&copy; {new Date().getFullYear()} Entreprenør Jan Nørgaard ApS. CVR-nr: 33768818. Alle rettigheder forbeholdes.</p>
          <div className="flex gap-4">
            <Link to="/403" className="hover:text-brand-navy-300 transition-colors">
              Privatlivspolitik
            </Link>
            <span>&middot;</span>
            <span>Udviklet af Auxo</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
